import axios from "../axios";

export default class LowProductionServices {
  async finishService(osRequestData) {
    let res = await axios.post(
      "Attendance/finish-attendance-dynamic",
      osRequestData,
    );
    return res.data;
  }

  async getCitiesActives() {
    let res = await axios.get("City/actives");
    return res.data;
  }

  async getTypeOsActives() {
    let res = await axios.get("TypeOs/actives");
    return res.data;
  }

  async getTypeOsByServiceOption(idService) {
    let res = await axios.get(
      `TypeOs/serviceOptions?id_service_option=${idService}`,
    );
    return res.data;
  }

  async getTypeOsByName(name_typeos) {
    let res = await axios.get("TypeOs/getForName?name_typeos=" + name_typeos);
    return res.data;
  }

  async getTypeOsByClassification(id_acao) {
    let res = await axios.get("TypeOs/forclassification?id_acao=" + id_acao);
    return res.data;
  }

  async getTypeOsClassificationByCity() {
    let res = await axios.get(
      `TypeOs/getForTypeLow?name_lowtype=PRODUTIVA_MOVIMENTACAO`,
    );
    return res.data;
  }

  async getAccreditedsActives() {
    let res = await axios.get("Accrediteds/actives");
    return res.data;
  }

  async getAccreditedsContingency() {
    let res = await axios.get("Accrediteds/actives-contingency");
    return res.data;
  }

  async getWriteOffCodeActives() {
    let res = await axios.get("CodBaixa/actives");
    return res.data;
  }

  async getWriteOffCodeActivesByType(lowtype) {
    let res = await axios.get(
      "CodBaixa/getByWriteOffType?name_lowtype=" + lowtype,
    );
    return res.data;
  }

  async getWriteOffCodeByTypeOs(typeOs) {
    let res = await axios.get("CodBaixa/getByOSfType?type_os=" + typeOs);
    return res.data;
  }

  async getWriteOffCodeByLowType(lowtype) {
    if (lowtype == null) {
      return [];
    }
    let res = await axios.get("CodBaixa/getByLowType?low_type=" + lowtype);
    return res.data;
  }

  // async getCitiesActives(lowtype) {
  //   let res = await axios.get(
  //     "CodBaixa/getByLowType?low_type=" + lowtype
  //   );
  //   return res.data;
  // }

  async getCityByCodeCity(codeCity) {
    let res = await axios.get(
      "City/GetCityByCode?code_city_netsms=" + codeCity,
    );
    return res.data;
  }

  async getCodeCityByName(nameCity) {
    let res = await axios.get("City/GetCodeCityByName?name_city=" + nameCity);
    return res.data;
  }

  async generateNewTokenWithDataTechnicianBaseAndRedirectServiceHistory(data) {
    let res = await axios.post("User/getaccess", data);
    return res.data;
  }

  async editTechnicianPhoneNumberAndAccredite(data) {
    let res = await axios.put("Technician", data);
    return res.data;
  }

  async saveGenerateOs(data) {
    let res = await axios.post("Attendance/finish-attendance-dynamic", data);
    return res.data;
  }

  async saveTechnicianPhoneNumberAndAccredite(data) {
    let res = await axios.post("Technician", data);
    return res.data;
  }

  async getTypeOsFixed() {
    let res = await axios.get("/TypeOsFixed/actives");
    return res.data;
  }

  async getLowType(typeOsId) {
    console.log("typeOsId", typeOsId);
    let res = await axios.get(`/TypeOs/getForTypeLow?name_lowtype=${typeOsId}`);
    return res.data;
  }

  async getLowTypeByCityCode(typeOsName, codCity) {
    let res = await axios.get(
      `/TypeOs/getForTypeLow?name_lowtype=${typeOsName}&cod_city=${codCity}`,
    );
    return res.data;
  }

  async getLowTypeLowAndActionMove(typeOsId, idClassification) {
    let res = await axios.get(
      `/TypeOs/getForTypeLowAndActionMove?name_lowtype=${typeOsId}&id_classification=${idClassification}`,
    );
    return res.data;
  }

  async getAllActions() {
    let res = await axios.get("/Report/getAllActions");
    return res.data;
  }

  async getAllStateEquipaments() {
    let res = await axios.get("/Report/getAllStateEquipaments");
    return res.data;
  }

  async getServiceOptionList(typeAttendance) {
    let url = "/Attendance/get-service-option";
    if (typeAttendance) {
      url += "?type_attendance=" + typeAttendance;
    }
    let res = await axios.get(url);
    return res.data;
  }

  async getTypeOsById(idService, id_typeos) {
    let res = await axios.get(
      `TypeOs/serviceOptions?id_service_option=${idService}&id_tipoos=${id_typeos}`,
    );
    return res.data;
  }

  async getWriteOffCodeByTypeOsAndTypeAttendance(typeOs, typeAttendance) {
    let res = await axios.get(
      "CodBaixa/getByWriteOffType?type_os=" +
        typeOs +
        "&type_attendance=" +
        typeAttendance,
    );
    return res.data;
  }
}
